export default class SelectedData {
    constructor(dateRange, userIds) {
        this.dateRange = dateRange;
        this.userIds = userIds;
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/model/SelectedData.js